const integrationOptions = [
  {
    id: 'WEB_APP',
    title: 'Web App',
    codeConfig: {
      internalAuth: `<script
    src="[[BUZZONE_URL]]/akademy/widget/app.js?appId=[[APP_ID]]"
    defer
></script>
<akadmy-widget
    app-id="[[APP_ID]]"
></akadmy-widget>`,
      externalAuth: `<script
    src="[[BUZZONE_URL]]/akademy/widget/app.js?appId=[[APP_ID]]"
    defer
></script>
<akadmy-widget
    app-id="[[APP_ID]]"
    user-email="[[USER_EMAIL]]"
></akadmy-widget>`,
    },
    instructions: [`Copy and paste this code in index.html`],
  },
  {
    id: 'REACT_APP',
    title: 'React App',
    codeConfig: {
      internalAuth: `import React, { useEffect } from "react";

export const AkadmyWidget = () => {

    const appId = "[[APP_ID]]";

    useEffect(() => {
        if (!appId) return;

        // Remove existing script to prevent duplicates
        const existingScript = document.getElementById("akadmy-widget-script");
        if (existingScript) {
            existingScript.remove();
        }

        // Create and append script
        const script = document.createElement("script");
        script.id = "akadmy-widget-script";
        script.src = \`[[BUZZONE_URL]]/akademy/widget/app.js?appId=\${appId}\`;
        script.defer = true;
        document.head.appendChild(script);

        // Cleanup
        return () => {
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        };
    }, [appId]); // Re-load if appId changes;

    if (!appId) return null; // Wait for data

    return <akadmy-widget app-id={appId} />;
};`,
      externalAuth: `import React, { useEffect } from "react";

export const AkadmyWidget = () => {

    const userEmail = "[[USER_EMAIL]]";
    const appId = "[[APP_ID]]";

    useEffect(() => {
        if (!appId || !userEmail) return;

        // Remove existing script to prevent duplicates
        const existingScript = document.getElementById("akadmy-widget-script");
        if (existingScript) {
            existingScript.remove();
        }

        // Create and append script
        const script = document.createElement("script");
        script.id = "akadmy-widget-script";
        script.src = \`[[BUZZONE_URL]]/akademy/widget/app.js?appId=\${appId}\`;
        script.defer = true;
        document.head.appendChild(script);

        // Cleanup
        return () => {
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        };
    }, [appId, userEmail]); // Re-load if appId or userEmail changes;

    if (!appId || !userEmail) return null; // Wait for data

    return <akadmy-widget app-id={appId} user-email={userEmail} />;
};`,
    },
    instructions: [
      'Copy, paste and create a new react component',
      'Place the component in app.jsx.',
      `[OPTIONAL - Applicalble only if "External" authentication mode is selected]
			"userEmail" is a dynamic value. In a react app, it is commonly fetched from any state management tool (like, Redux, Zustand, Jotai, or the built-in Context API), which keeps tracks of the logged in user.`,
    ],
  },
];

export default integrationOptions;
